import type { NotifyPort } from '@/features/messages/domain/notify'
import type { Member, WorkflowPort } from '../domain/workflow'

const listMembers = async (port: WorkflowPort, teamId: string, notify: NotifyPort): Promise<Member[]> => {
	try {
		return await port.listMembers(teamId)
	} catch {
		notify.error('workflow.teamMembersLoadFailed')
		return []
	}
}

export { listMembers }
